import {useSearchOptions} from "../../../hooks/useSearchOptions";
import {useGetControllerListUrl} from "./useGetControllerListUrl";

export const useControllerSearchOptions = () => {
  const {controllerListURL} = useGetControllerListUrl();
  const options = useSearchOptions(controllerListURL, ["name"], false);

  const searchOptions = [
    {
      category: {label: "Name", value: "name"},
      operator: ["=", "contains"],
      isAllowCustomValue: true,
      options: options.name,
    },
  ];
  return {searchOptions};
};
